import type { $Fetch } from "ofetch";

export type PrintResponse = {
  usuario: string;
  cabecalho: string;
};

/**
 * Classe de gerenciamento de chamadas da API da impressão
 *
 * @class
 */
export default class PrintApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api: $Fetch;

  /**
   * Cria uma nova instância da classe PrintApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
   * Realiza a busca das configurações de impressão
   * @returns objeto de configuração de impressão
   */
  get() {
    return this.api<PrintResponse>(
      `/ConfiguracaoImpressao/BuscarCabecalhoRelatorio`,
      {
        method: "GET",
      },
    );
  }

  /**
   * Realiza o cadastro de uma json string da configuração de impressão
   * @param valor - json string da configuração de impressão
   * @returns boolean
   */
  post(valor: string) {
    return this.api<boolean>(`/ConfiguracaoImpressao/CadastrarCabecalho`, {
      method: "POST",
      body: {
        CodUsuario: 1,
        Parametro: "CABECALHO_RELATORIO",
        RegistroAplicacao: "MEDWARE_LAUDOSUX_RELATORIO",
        Valor: valor,
      },
    });
  }
}
